import { ErrorResponse } from '../../../../@types';

export interface FuelTransactionFlag {
  rule?: string | null;
  reason?: string | null;
}

export interface FuelTransaction {
  id: string;
  uniqueId?: string | null;
  type?: string | null;
  timestamp?: string | null;
  fuelStationBrand?: string | null;
  fuelStationBrandName?: string | null;
  fuelStationAddress?: string | null;
  plate?: string | null;
  carId?: string | null;
  code?: string | null;
  tripId?: string | null;
  userReferralCode?: string | null;
  userId?: string | null;
  fleetId?: string | null;
  fleetName?: string | null;
  brandId?: string | null;
  brandName?: string | null;
  merchantId?: string | null;
  merchantName?: string | null;
  netAmount?: number | null;
  vatAmount?: number | null;
  amountTotal?: number | null;
  cardNumber?: string | null;
  product?: string | null;
  quantity?: number | null;
  pricePerLitre?: number | null;
  fuelLevelBefore?: number | null;
  fuelLevelAfter?: number | null;
  flagged?: boolean | null;
  flags?: FuelTransactionFlag[] | null;
}

export interface FuelTransactionsState {
  entities: FuelTransaction[] | null;
  display: FuelTransaction[] | null;
  selected: FuelTransaction | null;
  error: ErrorResponse | null;
  loading: boolean;
  fuelTransactionLoading: boolean;
  total: number | null;
}

export const initialState: FuelTransactionsState = {
  entities: null,
  display: null,
  selected: null,
  error: null,
  loading: false,
  fuelTransactionLoading: false,
  total: null,
};
